import { HttpErrorResponse } from '@angular/common/http';
import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatInput } from '@angular/material/input';
import { Router } from '@angular/router';
import { timer } from 'rxjs';
import { scan, takeWhile, tap } from 'rxjs/operators';
import { SharedService } from '../services/shared/shared.service';

@Component({
  selector: 'takeoff-group-website-dialoge',
  templateUrl: './website-dialoge.component.html',
  styleUrls: ['./website-dialoge.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class WebsiteDialogeComponent implements OnInit {
  @ViewChild('closeOtpDialog') closeOtpDialog: ElementRef;
  suspeciousUser: boolean = false;
  showTimer: boolean = false;
  timer$: any;
  resendCont: number = 0;
  otp = new FormControl(null);
  newPassword = new FormControl(null);
  isLoading: boolean = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sharedService: SharedService,
    public dialog: MatDialog,
    private router: Router
  ) {}

  ngOnInit() {
    if (
      this.data.dialogType == 'default_email_otp' ||
      this.data.dialogType == 'default_mobile_otp'
    ) {
      this.timer();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.data = this.data;
  }

  timer() {
    this.showTimer = true;
    let counter = 30;
    this.timer$ = timer(0, 1000).pipe(
      scan(acc => --acc, 30),
      takeWhile(x => x >= 0)
    );
    timer(1000, 1000)
      .pipe(
        takeWhile(() => counter > 0),
        tap(() => counter--)
      )
      .subscribe(() => {
        this.showTimer = counter === 0 ? false : true;
      });
  }

  onPayuCancel() {
    this.dialog.open(WebsiteDialogeComponent, {
      data: {
        dialogType: 'payPal_cancel'
      }
    });
  }

  async submitOtp(value) {
    this.isLoading = true;
    const otpForm = this.data.otpForm;
    const isFormData = this.data.isFormData;

    const payload = {
      // ...this.data.formPayload,
      // ...this.data.response,
      otp: value
    };

    if (!this.data.newApi) {
      for (let key in this.data.response) {
        payload[key] = this.data.response[key];
      }
    } else {
      for (let key in this.data.formPayload) {
        payload[key] = this.data.formPayload[key];
      }
    }

    const formDataPayload = new FormData();
    formDataPayload.append('otp', value);

    if (isFormData) {
      console.log(this.data.formPayload, '---', 'this.data.formPayload');
      // this.data.formPayload.entries().forEach(([key, value]) => {
      //   // console.log(key, value, '---', 'key, value');
      //   formDataPayload.append(key, value);
      // });

      for (const pair of this.data.formPayload.entries()) {
        formDataPayload.append(pair[0], pair[1]);
      }
    }

    if (this.data.newApi) {
      try {
        const res = await this.sharedService.newSubmitOtp(
          isFormData ? formDataPayload : payload,
          this.data.formName,
          isFormData,
          this.data.newFormType || 'forms'
        );
        if (res.success) {
          this.dialog.closeAll();
          this.isLoading = false;
          if (this.data.navigateToThankYou) {
            this.router.navigate(['page', 'thank-you']);
          } else {
            this.dialog.open(WebsiteDialogeComponent, {
              data: {
                dialogType: this.data.successDialogType || 'default_success'
              }
            });
          }
        } else {
          this.otp.reset();
          this.otp.setValidators(() => {
            return { InValidOtp: true };
          });
          this.otp.updateValueAndValidity();
          this.isLoading = false;
        }
        this.otp.clearValidators();
        this.otp.updateValueAndValidity();
      } catch (error) {
        this.dialog.closeAll();
        this.isLoading = false;
        this.dialog.open(WebsiteDialogeComponent, {
          data: {
            dialogType: 'custom_fail',
            message: 'Something went wrong! Please try again.'
          }
        });
      }
    } else {
      try {
        const res = await this.sharedService.submitOtp(payload, otpForm);

        if (res.status) {
          this.dialog.closeAll();
          this.isLoading = false;
          this.dialog.open(WebsiteDialogeComponent, {
            data: {
              dialogType: this.data.successDialogType || 'default_success'
            }
          });
        } else {
          this.dialog.closeAll();
          this.isLoading = false;
          this.dialog.open(WebsiteDialogeComponent, {
            data: { dialogType: 'custom_fail', message: res.message }
          });
        }
        this.otp.clearValidators();
        this.otp.updateValueAndValidity();
      } catch (error) {
        if (error.status == 400) {
          this.otp.reset();
          this.otp.setValidators(() => {
            return { InValidOtp: true };
          });
          this.otp.updateValueAndValidity();
          this.isLoading = false;
        }
      }
    }
  }

  async onResendClick() {
    if (!this.data.newApi) {
      const formType = this.data.formType;
      const payload = this.data.formPayload;
      this.resendCont = this.resendCont + 1;
      this.showTimer = true;
      if (this.resendCont >= 2) {
        this.suspeciousUser = true;
        this.showTimer = false;
      } else {
        this.sharedService.reSubmitOtp(payload, formType).subscribe(res => res);
        this.suspeciousUser = false;
        this.timer();
      }
    } else {
      const isFormData = this.data.isFormData;

      const payload = {
        // ...this.data.formPayload,
        // ...this.data.response,
      };

      for (let key in this.data.formPayload) {
        payload[key] = this.data.formPayload[key];
      }

      const formDataPayload = new FormData();
      if (isFormData) {
        // this.data.formPayload.entries().forEach(([key, value]) => {
        //   // console.log(key, value, '---', 'key, value');
        //   formDataPayload.append(key, value);
        // });

        for (const pair of this.data.formPayload.entries()) {
          formDataPayload.append(pair[0], pair[1]);
        }
      }

      this.resendCont = this.resendCont + 1;
      this.showTimer = true;
      if (this.resendCont > 3) {
        this.suspeciousUser = true;
        this.showTimer = false;
      } else {
        console.log(
          'resend otp',
          payload,
          '---',
          isFormData,
          '---',
          formDataPayload
        );

        const res = await this.sharedService.resendOtp(
          isFormData ? formDataPayload : payload,
          this.data.formName,
          isFormData
        );

        console.log(res, '---', 'res');

        if (res.otp_sent) {
          this.suspeciousUser = false;
          this.timer();
        }

        // show error message
        if (res.error) {
          this.dialog.open(WebsiteDialogeComponent, {
            data: {
              dialogType: 'custom_fail',
              message: res.error
            }
          });
        }
      }
    }
  }

  async submitForgotPassword() {
    this.isLoading = true;
    const otpForm = this.data.otpForm;
    const payload = {
      form: 'otp',
      email: this.data.emailId,
      password: this.newPassword.value,
      otp: this.otp.value
    };
    try {
      const res = await this.sharedService.submitOtp(payload, otpForm);
      if (res.status) {
        this.dialog.closeAll();
        this.isLoading = false;
        this.dialog.open(WebsiteDialogeComponent, {
          data: {
            dialogType: this.data.successDialogType || 'default_success'
          }
        });
      } else {
        this.dialog.closeAll();
        this.isLoading = false;
        this.dialog.open(WebsiteDialogeComponent, {
          data: {
            dialogType: 'custom_fail',
            title: 'Failed Changing password!',
            message: res.message
          }
        });
      }
      this.otp.clearValidators();
      this.otp.updateValueAndValidity();
    } catch (error) {
      if (error.status == 400) {
        this.otp.reset();
        this.otp.setErrors(() => {
          return { InValidOtp: true };
        });
        // this.otp.updateValueAndValidity();
        this.isLoading = false;
      }
    }
  }
}
